module.exports = __webpack_public_path__ + "img/tuboconcable.c68803ce.jpg";